import React from 'react';
import { MarkdownContent } from './MarkdownContent';
import { parseSecretRequests } from '../utils';

interface AssistantMessageProps {
  content: string;
  id: string;
  applicationId?: string;
  onSendMessage?: (message: string, model: string) => void;
  onSecretSet?: (secretKey: string) => void;
  className?: string;
}

export const AssistantMessage: React.FC<AssistantMessageProps> = ({
  content,
  id,
  applicationId,
  onSendMessage,
  onSecretSet,
  className = '',
}) => {
  // Remove trailing colon
  let processedContent = content.endsWith(':') ? content.slice(0, -1) : content;

  // Parse for secret requests
  const parts = parseSecretRequests(processedContent);

  // If no secret requests, render normally
  if (parts.length === 1 && parts[0].type === 'text') {
    return (
      <div data-msg-id={id} className={className}>
        <MarkdownContent content={processedContent} variant="agent" />
      </div>
    );
  }

  // Render with secret request components inline
  return (
    <div data-msg-id={id} className={className}>
      {parts.map((part, index) => {
        if (part.type === 'text') {
          return (
            <MarkdownContent
              key={index}
              content={part.content}
              variant="agent"
            />
          );
        } else if (part.type === 'secret' && part.secretKey && applicationId) {
          // Import SecretInput dynamically to avoid circular dependencies
          const SecretInput = require('../../AppEditor/SecretInput').SecretInput;
          return (
            <SecretInput
              key={index}
              secretKey={part.secretKey}
              applicationId={applicationId}
              onSecretSet={(key: string) => {
                onSecretSet?.(key);
                // Send a message to continue the agent after secret is set
                if (onSendMessage) {
                  onSendMessage(
                    `I've set the secret "${key}". Please continue.`,
                    'claude-haiku-4-5'
                  );
                }
              }}
            />
          );
        }
        return null;
      })}
    </div>
  );
};
